import { Text, View } from "@react-pdf/renderer";

export function PatientVisitDetails({
  styles,
  firstName,
  lastName,
  dateOfService,
  accountNumber,
  insuranceInfo,
  isCreatedWithDirectPay,
}: {
  styles: any;
  firstName: string;
  lastName: string;
  dateOfService: string;
  accountNumber?: string;
  insuranceInfo?: string | null;
  isCreatedWithDirectPay: boolean;
}) {
  return (
    <View style={styles.subsection}>
      <Text style={styles.title}>Patient Details</Text>
      <Text style={styles.text}>
        <Text style={styles.subtitle}>Patient:</Text>
        {"  "}
        {`${firstName} ${lastName}`}
      </Text>
      {!isCreatedWithDirectPay && (
        <Text style={styles.text}>
          <Text style={styles.subtitle}>Visit Date:</Text> {"  "}
          {dateOfService}
        </Text>
      )}
      {accountNumber && (
        <Text style={styles.text}>
          <Text style={styles.subtitle}>Account Number:</Text> {"  "}
          {accountNumber}
        </Text>
      )}
      {insuranceInfo && (
        <Text style={styles.text}>
          <Text style={styles.subtitle}>Insurance:</Text> {"  "}
          {insuranceInfo}
        </Text>
      )}
    </View>
  );
}
